const state = {
  condition: '',
  qtype: ''
}
const getters = {
  condition_ (state) {
    return state.condition
  },
  qtype_ (state) {
    return state.qtype
  }
}
const mutations = {
  setCondition (state, condition) {
    state.condition = condition
  },
  setQtype (state, qtype) {
    state.qtype = qtype
  }
}
const actions = {

}
export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
}
